module.exports = __webpack_public_path__ + "img/card.d8bc0edd.png";